// extracted by mini-css-extract-plugin
export var container = "_dk-1";
export var cornerButtonContainer = "_dk-6";
export var disabled = "_dk-2";
export var dragActive = "_dk-3";
export var fileContainer = "_dk-5";
export var hiddenInput = "_dk-4";
export var widthContainer = "_dk-0";